const color = [
  "primary",
  "status-green",
  "status-red",
  "status-yellow",
  "status-orange",
  "status-gray",
  "status-blue",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle",
  "ghost",
  "link"
] as const

const size = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
] as const

export default {
  "slots": {
    "base": [
      "rounded-md font-medium inline-flex items-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75",
      "transition-colors"
    ],
    "label": "truncate",
    "leadingIcon": "shrink-0",
    "leadingAvatar": "shrink-0",
    "leadingAvatarSize": "",
    "trailingIcon": "shrink-0"
  },
  "variants": {
    "fieldGroup": {
      "horizontal": "not-only:first:rounded-e-none not-only:last:rounded-s-none not-last:not-first:rounded-none focus-visible:z-[1]",
      "vertical": "not-only:first:rounded-b-none not-only:last:rounded-t-none not-last:not-first:rounded-none focus-visible:z-[1]"
    },
    "color": {
      "primary": "",
      "status-green": "",
      "status-red": "",
      "status-yellow": "",
      "status-orange": "",
      "status-gray": "",
      "status-blue": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": "",
      "ghost": "",
      "link": ""
    },
    "size": {
      "xs": {
        "base": "px-2 py-1 text-xs gap-1",
        "leadingIcon": "size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "size-4"
      },
      "sm": {
        "base": "px-2.5 py-1.5 text-xs gap-1.5",
        "leadingIcon": "size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "size-4"
      },
      "md": {
        "base": "px-2.5 py-1.5 text-sm gap-1.5",
        "leadingIcon": "size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "size-5"
      },
      "lg": {
        "base": "px-3 py-2 text-sm gap-2",
        "leadingIcon": "size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "size-5"
      },
      "xl": {
        "base": "px-3 py-2 text-base gap-2",
        "leadingIcon": "size-6",
        "leadingAvatarSize": "xs",
        "trailingIcon": "size-6"
      }
    },
    "block": {
      "true": {
        "base": "w-full justify-center",
        "trailingIcon": "ms-auto"
      }
    },
    "square": {
      "true": ""
    },
    "leading": {
      "true": ""
    },
    "trailing": {
      "true": ""
    },
    "loading": {
      "true": ""
    },
    "active": {
      "true": {
        "base": ""
      },
      "false": {
        "base": ""
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary hover:bg-primary/75 active:bg-primary/75 disabled:bg-primary aria-disabled:bg-primary outline-primary/25 focus-visible:outline-3"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-green hover:bg-status-green/75 active:bg-status-green/75 disabled:bg-status-green aria-disabled:bg-status-green outline-status-green/25 focus-visible:outline-3"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-red hover:bg-status-red/75 active:bg-status-red/75 disabled:bg-status-red aria-disabled:bg-status-red outline-status-red/25 focus-visible:outline-3"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-yellow hover:bg-status-yellow/75 active:bg-status-yellow/75 disabled:bg-status-yellow aria-disabled:bg-status-yellow outline-status-yellow/25 focus-visible:outline-3"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-orange hover:bg-status-orange/75 active:bg-status-orange/75 disabled:bg-status-orange aria-disabled:bg-status-orange outline-status-orange/25 focus-visible:outline-3"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-gray hover:bg-status-gray/75 active:bg-status-gray/75 disabled:bg-status-gray aria-disabled:bg-status-gray outline-status-gray/25 focus-visible:outline-3"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-status-blue hover:bg-status-blue/75 active:bg-status-blue/75 disabled:bg-status-blue aria-disabled:bg-status-blue outline-status-blue/25 focus-visible:outline-3"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-secondary hover:bg-secondary/75 active:bg-secondary/75 disabled:bg-secondary aria-disabled:bg-secondary outline-secondary/25 focus-visible:outline-3"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-success hover:bg-success/75 active:bg-success/75 disabled:bg-success aria-disabled:bg-success outline-success/25 focus-visible:outline-3"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-info hover:bg-info/75 active:bg-info/75 disabled:bg-info aria-disabled:bg-info outline-info/25 focus-visible:outline-3"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-warning hover:bg-warning/75 active:bg-warning/75 disabled:bg-warning aria-disabled:bg-warning outline-warning/25 focus-visible:outline-3"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-error hover:bg-error/75 active:bg-error/75 disabled:bg-error aria-disabled:bg-error outline-error/25 focus-visible:outline-3"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary/50 text-primary hover:bg-primary/10 active:bg-primary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-green/50 text-status-green hover:bg-status-green/10 active:bg-status-green/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-green/25 focus-visible:outline-3 focus-visible:ring-status-green"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-red/50 text-status-red hover:bg-status-red/10 active:bg-status-red/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-red/25 focus-visible:outline-3 focus-visible:ring-status-red"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-yellow/50 text-status-yellow hover:bg-status-yellow/10 active:bg-status-yellow/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-yellow/25 focus-visible:outline-3 focus-visible:ring-status-yellow"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-orange/50 text-status-orange hover:bg-status-orange/10 active:bg-status-orange/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-orange/25 focus-visible:outline-3 focus-visible:ring-status-orange"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-gray/50 text-status-gray hover:bg-status-gray/10 active:bg-status-gray/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-gray/25 focus-visible:outline-3 focus-visible:ring-status-gray"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-status-blue/50 text-status-blue hover:bg-status-blue/10 active:bg-status-blue/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-status-blue/25 focus-visible:outline-3 focus-visible:ring-status-blue"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-secondary/50 text-secondary hover:bg-secondary/10 active:bg-secondary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-success/50 text-success hover:bg-success/10 active:bg-success/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-info/50 text-info hover:bg-info/10 active:bg-info/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-warning/50 text-warning hover:bg-warning/10 active:bg-warning/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-error/50 text-error hover:bg-error/10 active:bg-error/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary bg-primary/10 hover:bg-primary/15 active:bg-primary/15 outline-primary/25 focus-visible:outline-3 disabled:bg-primary/10 aria-disabled:bg-primary/10"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-green bg-status-green/10 hover:bg-status-green/15 active:bg-status-green/15 outline-status-green/25 focus-visible:outline-3 disabled:bg-status-green/10 aria-disabled:bg-status-green/10"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-red bg-status-red/10 hover:bg-status-red/15 active:bg-status-red/15 outline-status-red/25 focus-visible:outline-3 disabled:bg-status-red/10 aria-disabled:bg-status-red/10"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-yellow bg-status-yellow/10 hover:bg-status-yellow/15 active:bg-status-yellow/15 outline-status-yellow/25 focus-visible:outline-3 disabled:bg-status-yellow/10 aria-disabled:bg-status-yellow/10"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-orange bg-status-orange/10 hover:bg-status-orange/15 active:bg-status-orange/15 outline-status-orange/25 focus-visible:outline-3 disabled:bg-status-orange/10 aria-disabled:bg-status-orange/10"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-gray bg-status-gray/10 hover:bg-status-gray/15 active:bg-status-gray/15 outline-status-gray/25 focus-visible:outline-3 disabled:bg-status-gray/10 aria-disabled:bg-status-gray/10"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-status-blue bg-status-blue/10 hover:bg-status-blue/15 active:bg-status-blue/15 outline-status-blue/25 focus-visible:outline-3 disabled:bg-status-blue/10 aria-disabled:bg-status-blue/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-secondary bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 outline-secondary/25 focus-visible:outline-3 disabled:bg-secondary/10 aria-disabled:bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-success bg-success/10 hover:bg-success/15 active:bg-success/15 outline-success/25 focus-visible:outline-3 disabled:bg-success/10 aria-disabled:bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-info bg-info/10 hover:bg-info/15 active:bg-info/15 outline-info/25 focus-visible:outline-3 disabled:bg-info/10 aria-disabled:bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-warning bg-warning/10 hover:bg-warning/15 active:bg-warning/15 outline-warning/25 focus-visible:outline-3 disabled:bg-warning/10 aria-disabled:bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-error bg-error/10 hover:bg-error/15 active:bg-error/15 outline-error/25 focus-visible:outline-3 disabled:bg-error/10 aria-disabled:bg-error/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary ring ring-inset ring-primary/25 bg-primary/10 hover:bg-primary/15 active:bg-primary/15 disabled:bg-primary/10 aria-disabled:bg-primary/10 outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-green ring ring-inset ring-status-green/25 bg-status-green/10 hover:bg-status-green/15 active:bg-status-green/15 disabled:bg-status-green/10 aria-disabled:bg-status-green/10 outline-status-green/25 focus-visible:outline-3 focus-visible:ring-status-green"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-red ring ring-inset ring-status-red/25 bg-status-red/10 hover:bg-status-red/15 active:bg-status-red/15 disabled:bg-status-red/10 aria-disabled:bg-status-red/10 outline-status-red/25 focus-visible:outline-3 focus-visible:ring-status-red"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-yellow ring ring-inset ring-status-yellow/25 bg-status-yellow/10 hover:bg-status-yellow/15 active:bg-status-yellow/15 disabled:bg-status-yellow/10 aria-disabled:bg-status-yellow/10 outline-status-yellow/25 focus-visible:outline-3 focus-visible:ring-status-yellow"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-orange ring ring-inset ring-status-orange/25 bg-status-orange/10 hover:bg-status-orange/15 active:bg-status-orange/15 disabled:bg-status-orange/10 aria-disabled:bg-status-orange/10 outline-status-orange/25 focus-visible:outline-3 focus-visible:ring-status-orange"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-gray ring ring-inset ring-status-gray/25 bg-status-gray/10 hover:bg-status-gray/15 active:bg-status-gray/15 disabled:bg-status-gray/10 aria-disabled:bg-status-gray/10 outline-status-gray/25 focus-visible:outline-3 focus-visible:ring-status-gray"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-status-blue ring ring-inset ring-status-blue/25 bg-status-blue/10 hover:bg-status-blue/15 active:bg-status-blue/15 disabled:bg-status-blue/10 aria-disabled:bg-status-blue/10 outline-status-blue/25 focus-visible:outline-3 focus-visible:ring-status-blue"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 disabled:bg-secondary/10 aria-disabled:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-success ring ring-inset ring-success/25 bg-success/10 hover:bg-success/15 active:bg-success/15 disabled:bg-success/10 aria-disabled:bg-success/10 outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-info ring ring-inset ring-info/25 bg-info/10 hover:bg-info/15 active:bg-info/15 disabled:bg-info/10 aria-disabled:bg-info/10 outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-warning ring ring-inset ring-warning/25 bg-warning/10 hover:bg-warning/15 active:bg-warning/15 disabled:bg-warning/10 aria-disabled:bg-warning/10 outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-error ring ring-inset ring-error/25 bg-error/10 hover:bg-error/15 active:bg-error/15 disabled:bg-error/10 aria-disabled:bg-error/10 outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-primary hover:bg-primary/10 active:bg-primary/10 outline-primary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-green hover:bg-status-green/10 active:bg-status-green/10 outline-status-green/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-red hover:bg-status-red/10 active:bg-status-red/10 outline-status-red/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-yellow hover:bg-status-yellow/10 active:bg-status-yellow/10 outline-status-yellow/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-orange hover:bg-status-orange/10 active:bg-status-orange/10 outline-status-orange/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-gray hover:bg-status-gray/10 active:bg-status-gray/10 outline-status-gray/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-status-blue hover:bg-status-blue/10 active:bg-status-blue/10 outline-status-blue/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-secondary hover:bg-secondary/10 active:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-success hover:bg-success/10 active:bg-success/10 outline-success/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-info hover:bg-info/10 active:bg-info/10 outline-info/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-warning hover:bg-warning/10 active:bg-warning/10 outline-warning/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-error hover:bg-error/10 active:bg-error/10 outline-error/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-primary hover:text-primary/75 active:text-primary/75 disabled:text-primary aria-disabled:text-primary outline-primary/25 focus-visible:outline-3"
    },
    {
      "color": "status-green" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-green hover:text-status-green/75 active:text-status-green/75 disabled:text-status-green aria-disabled:text-status-green outline-status-green/25 focus-visible:outline-3"
    },
    {
      "color": "status-red" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-red hover:text-status-red/75 active:text-status-red/75 disabled:text-status-red aria-disabled:text-status-red outline-status-red/25 focus-visible:outline-3"
    },
    {
      "color": "status-yellow" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-yellow hover:text-status-yellow/75 active:text-status-yellow/75 disabled:text-status-yellow aria-disabled:text-status-yellow outline-status-yellow/25 focus-visible:outline-3"
    },
    {
      "color": "status-orange" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-orange hover:text-status-orange/75 active:text-status-orange/75 disabled:text-status-orange aria-disabled:text-status-orange outline-status-orange/25 focus-visible:outline-3"
    },
    {
      "color": "status-gray" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-gray hover:text-status-gray/75 active:text-status-gray/75 disabled:text-status-gray aria-disabled:text-status-gray outline-status-gray/25 focus-visible:outline-3"
    },
    {
      "color": "status-blue" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-status-blue hover:text-status-blue/75 active:text-status-blue/75 disabled:text-status-blue aria-disabled:text-status-blue outline-status-blue/25 focus-visible:outline-3"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-secondary hover:text-secondary/75 active:text-secondary/75 disabled:text-secondary aria-disabled:text-secondary outline-secondary/25 focus-visible:outline-3"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-success hover:text-success/75 active:text-success/75 disabled:text-success aria-disabled:text-success outline-success/25 focus-visible:outline-3"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-info hover:text-info/75 active:text-info/75 disabled:text-info aria-disabled:text-info outline-info/25 focus-visible:outline-3"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-warning hover:text-warning/75 active:text-warning/75 disabled:text-warning aria-disabled:text-warning outline-warning/25 focus-visible:outline-3"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-error hover:text-error/75 active:text-error/75 disabled:text-error aria-disabled:text-error outline-error/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inverted hover:bg-inverted/90 active:bg-inverted/90 disabled:bg-inverted aria-disabled:bg-inverted outline-inverted/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-default hover:bg-elevated active:bg-elevated disabled:bg-default aria-disabled:bg-default outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 outline-inverted/25 focus-visible:outline-3 disabled:bg-elevated aria-disabled:bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 disabled:bg-elevated aria-disabled:bg-elevated outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-default hover:bg-elevated active:bg-elevated outline-inverted/25 focus-visible:outline-3 hover:disabled:bg-transparent dark:hover:disabled:bg-transparent hover:aria-disabled:bg-transparent dark:hover:aria-disabled:bg-transparent"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-muted hover:text-default active:text-default disabled:text-muted aria-disabled:text-muted outline-inverted/25 focus-visible:outline-3"
    },
    {
      "size": "xs" as typeof size[number],
      "square": true,
      "class": "p-1"
    },
    {
      "size": "sm" as typeof size[number],
      "square": true,
      "class": "p-1.5"
    },
    {
      "size": "md" as typeof size[number],
      "square": true,
      "class": "p-1.5"
    },
    {
      "size": "lg" as typeof size[number],
      "square": true,
      "class": "p-2"
    },
    {
      "size": "xl" as typeof size[number],
      "square": true,
      "class": "p-2"
    },
    {
      "loading": true,
      "leading": true,
      "class": {
        "leadingIcon": "animate-spin"
      }
    },
    {
      "loading": true,
      "leading": false,
      "trailing": true,
      "class": {
        "trailingIcon": "animate-spin"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "variant": "solid" as typeof variant[number],
    "size": "md" as typeof size[number]
  }
}